// framework/client/components/WorkflowFormComponent.js
import { ComponentBase } from "../core/ComponentBase.js";
import { VisualWorkflowBuilder } from "./VisualWorkflowBuilder.js";

export class WorkflowFormComponent extends ComponentBase {
    constructor(config) {
        super(config);
        this.workflowBuilder = null;
        this.workflowData = null;
        this.editButton = null;
    }

    async initialize() {
        await super.initialize();
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.id = `${this.config.eventGroup}-container`;
            this.container.className = 'workflow-form-component';

            this.editButton = document.createElement('button');
            this.editButton.type = 'button';
            this.editButton.className = 'btn btn-primary';
            this.editButton.textContent = 'Edit Workflow';
            this.editButton.addEventListener('click', this.handleEditClick.bind(this));
            this.container.appendChild(this.editButton);
        }

        return this.container;
    }

    async handleEditClick() {
        if (!this.workflowBuilder) {
            this.workflowBuilder = await this.createManagedComponent('VisualWorkflowBuilder', document.body, {
                instanceId: `${this.config.instanceId}-builder`,
            });

            this.workflowBuilder.on('workflowSaved', (savedData) => {
                this.log.info('Workflow data saved from builder:', savedData);
                this.workflowData = savedData;
                this.container.dispatchEvent(new Event('change', { bubbles: true }));
            });
        }

        if (this.workflowData) {
            this.workflowBuilder.setData(this.workflowData);
        }

        await this.workflowBuilder.show();
    }

    getValue() {
        if (this.workflowBuilder) {
            return this.workflowBuilder.getData();
        }
        return this.workflowData || [];
    }

    setValue(data) {
        this.workflowData = Array.isArray(data) ? data : [];

        if (this.workflowBuilder) {
            this.workflowBuilder.setData(this.workflowData);
        }
    }

    destroy() {
        if (this.workflowBuilder) {
            this.workflowBuilder.destroy();
            this.workflowBuilder = null;
        }
        super.destroy();
    }
}